<template lang="pug">
  .vx-card__title.mb-8
    div.flex.flex-wrap.justify-center
      h4.mb-4.Bienvenido {{ $t('seguimiento.welcome') }}
    div.flex.flex-wrap.justify-center
      p.Sigue-tus-envios-con-la-orden-de-transporte {{ $t('seguimiento.sigue') }}
    form.pt-3
      label(
        class="vs-select--label font-service"
      ) {{ $t('seguimiento.search') }}
      vs-input(
        class="w-full"
        v-validate="'required'"
        name="guia"
        v-model="code"
      )
      span.text-danger.text-sm(
        v-show="errors.has('guia')"
      ) {{ errors.first('guia') }}
    .flex.flex-wrap.justify-center
      vs-button.botones-search(
        :disabled="show_button"
        @click="setSave"
      ) {{ $t('seguimiento.search') }}
</template>
<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { encryptSearchCode } from '@/utils/encryption.js'

Vue.use(VueReCaptcha, { siteKey: '6LfuYt8UAAAAAEV9NXghwVshCa2SYWMZ8kqVe79i' })
export default {
  data() {
    return {
      code: '',
      token: '',
      show_button: false,
      infoData: null
    }
  },
  mounted() {
    if (this.$route.query.hasOwnProperty('guia')) {
      this.code = this.$route.query.guia
      // this.$router.push({ name: 'searchSp', params: { code: this.code } })
      this.setSave()
    }
  },
  methods: {
    async md5(message) {
      // Small MD5 implementation as SubtleCrypto doesn't support MD5
      const rotateLeft = (lValue, iShiftBits) => (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
      const addUnsigned = (lX, lY) => {
        const lX8 = (lX & 0x80000000);
        const lY8 = (lY & 0x80000000);
        const lX4 = (lX & 0x40000000);
        const lY4 = (lY & 0x40000000);
        const lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
        if (lX4 | lY4) {
          if (lResult & 0x40000000) return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
          else return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
        } else return (lResult ^ lX8 ^ lY8);
      };
      const F = (x, y, z) => (x & y) | ((~x) & z);
      const G = (x, y, z) => (x & z) | (y & (~z));
      const H = (x, y, z) => (x ^ y ^ z);
      const I = (x, y, z) => (y ^ (x | (~z)));
      const FF = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(F(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const GG = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(G(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const HH = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(H(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const II = (a, b, c, d, x, s, ac) => {
        a = addUnsigned(a, addUnsigned(addUnsigned(I(b, c, d), x), ac));
        return addUnsigned(rotateLeft(a, s), b);
      };
      const convertToWordArray = (string) => {
        let lWordCount;
        const lMessageLength = string.length;
        const lNumberOfWords_temp1 = lMessageLength + 8;
        const lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        const lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        const lWordArray = new Array(lNumberOfWords);
        let lBytePosition = 0;
        let lByteCount = 0;
        while (lByteCount < lMessageLength) {
          lWordCount = (lByteCount - (lByteCount % 4)) / 4;
          lBytePosition = (lByteCount % 4) * 8;
          lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
          lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
      };
      const wordToHex = (lValue) => {
        let WordToHexValue = "", WordToHexValue_temp = "", lByte, lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
          lByte = (lValue >>> (lCount * 8)) & 255;
          WordToHexValue_temp = "0" + lByte.toString(16);
          WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
      };
      const x = convertToWordArray(message);
      let a = 0x67452301, b = 0xEFCDAB89, c = 0x98BADCFE, d = 0x10325476;
      for (let k = 0; k < x.length; k += 16) {
        let AA = a, BB = b, CC = c, DD = d;
        a = FF(a, b, c, d, x[k + 0], 7, 0xD76AA478); d = FF(d, a, b, c, x[k + 1], 12, 0xE8C7B756); c = FF(c, d, a, b, x[k + 2], 17, 0x242070DB); b = FF(b, c, d, a, x[k + 3], 22, 0xC1BDCEEE);
        a = FF(a, b, c, d, x[k + 4], 7, 0xF57C0FAF); d = FF(d, a, b, c, x[k + 5], 12, 0x4787C62A); c = FF(c, d, a, b, x[k + 6], 17, 0xA8304613); b = FF(b, c, d, a, x[k + 7], 22, 0xFD469501);
        a = FF(a, b, c, d, x[k + 8], 7, 0x698098D8); d = FF(d, a, b, c, x[k + 9], 12, 0x8B44F7AF); c = FF(c, d, a, b, x[k + 10], 17, 0xFFFF5BB1); b = FF(b, c, d, a, x[k + 11], 22, 0x895CD7BE);
        a = FF(a, b, c, d, x[k + 12], 7, 0x6B901122); d = FF(d, a, b, c, x[k + 13], 12, 0xFD987193); c = FF(c, d, a, b, x[k + 14], 17, 0xA679438E); b = FF(b, c, d, a, x[k + 15], 22, 0x49B40821);
        a = GG(a, b, c, d, x[k + 1], 5, 0xF61E2562); d = GG(d, a, b, c, x[k + 6], 9, 0xC040B340); c = GG(c, d, a, b, x[k + 11], 14, 0x265E5A51); b = GG(b, c, d, a, x[k + 0], 20, 0xE9B6C7AA);
        a = GG(a, b, c, d, x[k + 5], 5, 0xD62F105D); d = GG(d, a, b, c, x[k + 10], 9, 0x02441453); c = GG(c, d, a, b, x[k + 15], 14, 0xD8A1E681); b = GG(b, c, d, a, x[k + 4], 20, 0xE7D3FBC8);
        a = GG(a, b, c, d, x[k + 9], 5, 0x21E1CDE6); d = GG(d, a, b, c, x[k + 14], 9, 0xC33707D6); c = GG(c, d, a, b, x[k + 3], 14, 0xF4D50D87); b = GG(b, c, d, a, x[k + 8], 20, 0x455A14ED);
        a = GG(a, b, c, d, x[k + 13], 5, 0xA9E3E905); d = GG(d, a, b, c, x[k + 2], 9, 0xFCEFA3F8); c = GG(c, d, a, b, x[k + 7], 14, 0x676F02D9); b = GG(b, c, d, a, x[k + 12], 20, 0x8D2A4C8A);
        a = HH(a, b, c, d, x[k + 5], 4, 0xFFFA3942); d = HH(d, a, b, c, x[k + 8], 11, 0x8771F681); c = HH(c, d, a, b, x[k + 11], 16, 0x6D9D6122); b = HH(b, c, d, a, x[k + 14], 23, 0xFDE5380C);
        a = HH(a, b, c, d, x[k + 1], 4, 0xA4BEEA44); d = HH(d, a, b, c, x[k + 4], 11, 0x4BDECFA9); c = HH(c, d, a, b, x[k + 7], 16, 0xF6BB4B60); b = HH(b, c, d, a, x[k + 10], 23, 0xBEBFBC70);
        a = HH(a, b, c, d, x[k + 13], 4, 0x289B7EC6); d = HH(d, a, b, c, x[k + 0], 11, 0xEAA127FA); c = HH(c, d, a, b, x[k + 3], 16, 0xD4EF3085); b = HH(b, c, d, a, x[k + 6], 23, 0x04881D05);
        a = HH(a, b, c, d, x[k + 9], 4, 0xD9D4D039); d = HH(d, a, b, c, x[k + 12], 11, 0xE6DB99E5); c = HH(c, d, a, b, x[k + 15], 16, 0x1FA27CF8); b = HH(b, c, d, a, x[k + 2], 23, 0xC4AC5665);
        a = II(a, b, c, d, x[k + 0], 6, 0xF4292244); d = II(d, a, b, c, x[k + 7], 10, 0x432AFF97); c = II(c, d, a, b, x[k + 14], 15, 0xAB9423A7); b = II(b, c, d, a, x[k + 5], 21, 0xFC93A039);
        a = II(a, b, c, d, x[k + 12], 6, 0x655B59C3); d = II(d, a, b, c, x[k + 3], 10, 0x8F0CCC92); c = II(c, d, a, b, x[k + 10], 15, 0xFFEFF47D); b = II(b, c, d, a, x[k + 1], 21, 0x85845DD1);
        a = II(a, b, c, d, x[k + 8], 6, 0x6FA87E4F); d = II(d, a, b, c, x[k + 15], 10, 0xFE2CE6E0); c = II(c, d, a, b, x[k + 6], 15, 0xA3014314); b = II(b, c, d, a, x[k + 13], 21, 0x4E0811A1);
        a = II(a, b, c, d, x[k + 4], 6, 0xF7537E82); d = II(d, a, b, c, x[k + 11], 10, 0xBD3AF235); c = II(c, d, a, b, x[k + 2], 15, 0x2AD7D2BB); b = II(b, c, d, a, x[k + 9], 21, 0xEB86D391);
        a = addUnsigned(a, AA); b = addUnsigned(b, BB); c = addUnsigned(c, CC); d = addUnsigned(d, DD);
      }
      return wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
    },
    async generarToken(guia) {
      console.log("Generando token para guía:", guia);
      const PREFIX = "65-A";
      const SALT = "gearnw87xyn348r72487248x7245mx74mx3h34";
      if (!guia) throw new Error("Guía requerida");
      const guiaStr = String(guia).trim();
      const base = PREFIX + guiaStr;
      const raw = base + SALT;
      console.log("Firma raw:", raw);
      const hash = await this.md5(raw);
      const tokenResult = `E${hash}${SALT}`;
      console.log("Hash generado:", hash);
      console.log("Token final:", tokenResult);
      return tokenResult;
    },
    async setSave() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.show_button = true
          this.token = this.$route.query.token
          
          const encryptedCode = encryptSearchCode(this.code);
          
          console.log("Guía original:", this.code);
          console.log("Código encriptado para URL:", encryptedCode);
          
          this.$router.push({ path: `/seguimiento/${encryptedCode}` })
        }
      })
    }
  },
}
</script>
<style>
.font-service {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2c2c2c;
}
.vs-inputx {
  height: 50px;
  margin: 1px 0 0;
  padding: 16px 260px 15px 10px;
  border-radius: 6px;
  border: solid 1px #6f6f76 !important;
  background-color: #f0f0f0;
}
.Rectangle-3 {
  width: 348px;
  height: 50px;
  margin: 1px 0 0;
  padding: 16px 260px 15px 10px;
  border-radius: 6px;
  border: solid 1px #6f6f76;
  background-color: #f0f0f0;
}
.Sigue-tus-envios-con-la-orden-de-transporte {
  width: 250px;
  height: 43px;
  flex-grow: 0;
  margin: 21px 0px 12px 0px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.Bienvenido {
  width: 84px;
  height: 19px;
  flex-grow: 0;
  margin: 12.3px 131px 2px 135px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.botones-search {
  width: 100%;
  height: 56px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 39px 0 0 0px;
  padding: 10px 8px;
  border-radius: 6px;
  background-color: #fdd402;
  font-weight: 800;
}
</style>